var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Dispose } from '../../store';
import { DefaultRequestPolicies } from './constants';
import { mapMerge } from './mapMerge';
import { purge } from './purge';
import { reset } from './reset';
import { createUpdateMapper } from './updateMapper';
export function resourceReducer(state, action) {
    if (!state) {
        state = reset();
    }
    switch (action.type) {
        case Dispose:
            return reset(state);
        case 'abandonTask': {
            var task = state.tasks.pending[action.taskId];
            if (!task) {
                return state;
            }
            return mapMerge(task.scope, state, task.pointers, function (pointerState) {
                switch (action.taskId) {
                    // Note: purges can't be abandoned, as it'd cause a memory leak.
                    case pointerState.tasks.invalidate:
                        return {
                            invalidated: false,
                            tasks: __assign(__assign({}, pointerState.tasks), { invalidate: false }),
                        };
                    case pointerState.tasks.load:
                        return {
                            tasks: __assign(__assign({}, pointerState.tasks), { load: false }),
                        };
                    case pointerState.tasks.manualLoad:
                        return {
                            tasks: __assign(__assign({}, pointerState.tasks), { manualLoad: null }),
                        };
                    case pointerState.tasks.subscribe:
                        return {
                            tasks: __assign(__assign({}, pointerState.tasks), { subscribe: false }),
                        };
                }
            });
        }
        case 'clearQueue':
            return __assign(__assign({}, state), { tasks: __assign(__assign({}, state.tasks), { queue: {} }) });
        case 'dropRequest':
            return mapMerge(action.scope, state, [action.request.root], function (refState) {
                if (!refState.request) {
                    return refState;
                }
                var nextRequestPolicies = __assign({}, refState.request.policies);
                for (var i = 0; i < action.policies.length; i++) {
                    --nextRequestPolicies[action.policies[i]];
                }
                var sum = nextRequestPolicies.loadInvalidated +
                    nextRequestPolicies.loadOnce +
                    nextRequestPolicies.subscribe;
                return {
                    modifiers: __assign(__assign({}, refState.modifiers), { keep: refState.modifiers.keep - 1 }),
                    request: sum === 0
                        ? null
                        : { instance: action.request, policies: nextRequestPolicies },
                };
            });
        case 'error':
            return __assign(__assign({}, reset(state)), { error: action.error });
        case 'invalidate': {
            if (action.taskId !== null && !state.tasks.pending[action.taskId]) {
                return state;
            }
            var scope = action.taskId
                ? state.tasks.pending[action.taskId].scope
                : action.scope;
            return mapMerge(scope, state, action.pointers, function (refState) {
                if (action.taskId === null ||
                    refState.tasks.invalidate === action.taskId) {
                    return {
                        invalidated: true,
                    };
                }
            });
        }
        case 'manualLoad':
            return mapMerge(action.scope, state, [action.request.root], function (refState, i, tracker) { return ({
                tasks: __assign(__assign({}, refState.tasks), { load: null, manualLoad: tracker.startRequestTasks('manualLoad', refState.pointer, action.request) }),
            }); });
        case 'applyModifiers':
            return mapMerge(action.scope, state, action.pointers, function (refState) {
                return {
                    modifiers: {
                        keep: refState.modifiers.keep + (action.keep || 0),
                        pause: refState.modifiers.pause + (action.pause || 0),
                        pending: refState.modifiers.pending + (action.pending || 0),
                    },
                };
            });
        case 'purge': {
            var task = state.tasks.pending[action.taskId];
            if (!task) {
                return state;
            }
            return purge(task.scope, state, action.pointers, action.taskId);
        }
        case 'registerRequest':
            return mapMerge(action.scope, state, [action.request.root], function (refState) {
                var nextPolicies = __assign({}, (refState.request
                    ? refState.request.policies
                    : DefaultRequestPolicies));
                for (var i = 0; i < action.policies.length; i++) {
                    ++nextPolicies[action.policies[i]];
                }
                return {
                    modifiers: __assign(__assign({}, refState.modifiers), { keep: refState.modifiers.keep + 1 }),
                    request: {
                        instance: action.request,
                        policies: nextPolicies,
                    },
                };
            });
        case 'updateValue': {
            var taskId = action.taskId;
            // Bail if the task has been stopped
            var previousTask = taskId && state.tasks.pending[taskId];
            if (taskId && !previousTask) {
                return state;
            }
            // Bail if the request task is no longer required
            var scope = previousTask ? previousTask.scope : action.scope;
            var root = (previousTask && previousTask.request.root) ||
                undefined;
            if (root) {
                var scopeState = state.data[scope];
                var rootState = scopeState &&
                    scopeState[root.bucket] &&
                    scopeState[root.bucket][root.id];
                var tasks = rootState && rootState.tasks;
                if (!tasks ||
                    (taskId !== null &&
                        taskId !== tasks.load &&
                        taskId !== tasks.manualLoad &&
                        taskId !== tasks.subscribe)) {
                    return state;
                }
            }
            return mapMerge(scope, state, action.chunks, createUpdateMapper(taskId, action.timestamp, action.chunks));
        }
        default:
            return state;
    }
}
//# sourceMappingURL=cacheReducer.js.map